export default "__VITE_ASSET__D8VMYXs4__"